// Handle for uncaught errors during component render function and watchers
import * as Sentry from '@sentry/vue';

export const errorHandler = (err) => {
  Sentry.captureException(err);
  console.error(err);
};

export const warnHandler = (warn) => {
  Sentry.captureEvent(warn);
  console.warn(warn);
};
